"use client";

import { getBookerWrapperClasses } from "@calcom/features/bookings/Booker/utils/getBookerWrapperClasses";
import { TenantBrandingProvider } from "@calcom/lib/tenantBrandingContext";
import { BookerWebWrapper as Booker } from "@calcom/web/modules/bookings/components/BookerWebWrapper";
import BookingPageErrorBoundary from "@components/error/BookingPageErrorBoundary";
import type { inferSSRProps } from "@lib/types/inferSSRProps";
import type { getServerSideProps } from "@server/lib/team/[slug]/[type]/getServerSideProps";
import type { EmbedProps } from "app/WithEmbedSSR";

export type TeamTypePageProps = inferSSRProps<typeof getServerSideProps> & EmbedProps;

export default function TeamTypePage({
  slug,
  user,
  isEmbed,
  booking,
  isBrandingHidden,
  eventData,
  duration,
  tenant,
}: TeamTypePageProps) {
  return (
    <TenantBrandingProvider tenant={tenant}>
      <BookingPageErrorBoundary>
      <main className={getBookerWrapperClasses({ isEmbed: !!isEmbed })}>
        <Booker
          username={user}
          eventSlug={slug}
          bookingData={booking}
          hideBranding={isBrandingHidden}
          eventData={eventData}
          entity={{ ...eventData.entity, eventTypeId: eventData.id }}
          durationConfig={eventData.metadata?.multipleDuration}
          duration={duration}
          isTeamEvent
          // Team events would otherwise ask API v2 for slots, which this deployment does not run.
          useApiV2={false}
        />
      </main>
      </BookingPageErrorBoundary>
    </TenantBrandingProvider>
  );
}
